// @ts-nocheck
import * as React from 'react';
import type { LayoutProps } from '@oneaudi/unified-web-components';
import { ButtonGroup, TextButton } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import type { MyAudiBarButtonConfig } from '../../../types';
import { ErrorMessage } from './ErrorMessage/ErrorMessage';
import { useTrackingManager } from '../../../hooks/useTrackingManager';
import MyAudiCtaDisclaimer from '../../common/MyAudiCtaDisclaimer/MyAudiCtaDisclaimer';

export type CtaBarProps = LayoutProps & {
  myAudiCtaButtonConfig: MyAudiBarButtonConfig;
  errorMessage: { code: string; message: string } | undefined;
  displayname: string;
};

export const MyAudiCtaBar = ({
  myAudiCtaButtonConfig,
  errorMessage,
  displayname,
}: CtaBarProps): React.ReactElement | null => {
  const { selectedPartner, favoritePartner, changeCta, setCta } = myAudiCtaButtonConfig;
  const trackingManager = useTrackingManager();

  if (!favoritePartner) {
    return (
      <ButtonContainer margin={['24px', 0, '24px', 0]}>
        {errorMessage && <ErrorMessage message={errorMessage.message} />}

        <TextButton
          variant="primary"
          onClick={(event) => {
            setCta.setFunction(event, 'set');
            trackingManager.click(
              'content',
              'favorite-partner',
              'cta',
              setCta.label,
              displayname,
              '1',
              setCta.label,
            );
          }}
        >
          {setCta.label}
        </TextButton>
        <MyAudiCtaDisclaimer />
      </ButtonContainer>
    );
  }
  if (favoritePartner !== selectedPartner) {
    return (
      <ButtonContainer margin={['24px', 0, '24px', 0]}>
        {errorMessage && <ErrorMessage message={errorMessage.message} />}
        <TextButton
          variant="primary"
          onClick={(event) => {
            changeCta.changeFunction(event, 'change');
            trackingManager.click(
              'content',
              'favorite-partner',
              'cta',
              changeCta.label,
              displayname,
              '1',
              changeCta.label,
            );
          }}
        >
          {changeCta.label}
        </TextButton>
        <MyAudiCtaDisclaimer />
      </ButtonContainer>
    );
  }

  return null;
};

const ButtonContainer = styled(ButtonGroup)`
  display: block;
  > div {
    display: inline-grid;
  }
`;
